module.exports = "https://web-assets.ifttt.com/packs/media/partners/maker_documentation-d1608b13.svg";